import { ReactComponent } from "./lock-line.svg";

const LockLineIcon = () => <ReactComponent />;

export default LockLineIcon;
